import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { requestPortalAccess, portalDevLoginUrl } from '@/lib/api/endpoints/portal';
import './portal.css';

export function PortalLogin() {
  const { workspaceId = '' } = useParams<{ workspaceId: string }>();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    // DEV-ONLY: skip the email round-trip — log straight in via the gated
    // dev-login endpoint (404s in prod). Production keeps the magic-link flow.
    if (import.meta.env.DEV) {
      window.location.href = portalDevLoginUrl(workspaceId, email.trim());
      return;
    }
    setLoading(true);
    try {
      await requestPortalAccess(workspaceId, email.trim());
    } catch {
      // Always show success — don't reveal whether email is registered
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="portal-root">
      <div className="portal-card">
        <h1>Sign in</h1>
        <p>Enter your email and we'll send you a sign-in link.</p>
        {submitted ? (
          <div className="portal-success">
            Check your email for a sign-in link.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              className="portal-input"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
            <button className="portal-btn" type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send me a link'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
